// extracted by mini-css-extract-plugin
export var freeGiftBannerWrapper = "free-gift-banner-module--free-gift-banner-wrapper--ebc40";